import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { "data-test-id": "product_list_component" }

import { onMounted } from 'vue';
import { useI18n } from 'vue-i18n';
import { ISitecoreFormGenericInput } from '@/interfaces';
import FormStepInputs from '@/components/FormStepInputs/FormStepInputs.vue';
import ProductCardList from '@/components/ProductCardList/ProductCardList.vue';
import { useAccountStore } from '@/store';
import { PageAnalyticsBuilder } from '@/utils/page-analytics-builder';


export default /*@__PURE__*/_defineComponent({
  __name: 'Insurance',
  props: {
    content: {},
    id: {},
    name: {}
  },
  setup(__props: any) {

const props = __props;

const accountStore = useAccountStore();
const yourProducts = props.content.find((item) => item.formInputId.value == 'yourProducts');
const dictionary = useI18n().getLocaleMessage('en') as Record<string, string>;

onMounted(() => {
  pushAnalytics();
});

const pushAnalytics = async () => {
  const pageAnalytics = new PageAnalyticsBuilder();
  pageAnalytics.populateProducts(dictionary);
  pageAnalytics.pushAnalytics();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(FormStepInputs, {
      step: {
        stepName: _ctx.name,
        formInputs: _ctx.content,
      }
    }, {
      yourProducts: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createVNode(ProductCardList, {
            fields: _unref(yourProducts),
            hideAssistance: true,
            hideBank: true,
            portfolio: _unref(accountStore).identityDetails?.portfolio
          }, null, 8, ["fields", "portfolio"])
        ])
      ]),
      _: 1
    }, 8, ["step"])
  ]))
}
}

})